module.exports = __webpack_public_path__ + "static/img/img-ybj.3289dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-ybj.png
// module id = xdDy
// module chunks = 0